import { useNavigation } from 'react-day-picker';
import css from './Caption.module.scss';
import moment from 'moment';
import { svgSprite } from '../../../../hybrid/wrappers';
import classNames from 'classnames';

export default function Caption() {
    const { goToMonth, nextMonth, previousMonth, currentMonth } = useNavigation();
    const currentMon = moment(currentMonth).format('MMMM YYYY');
    const monthHandler = (month) => {
        goToMonth(month);
    };
    return (
        <div className={css.wrapper}>
            <div onClick={() => monthHandler(previousMonth)} className={classNames(css.arrow, 'grow')}>
                {svgSprite('events-calendar-arrow-left', { className: css.svg })}
            </div>
            <div className={css.title}>{currentMon}</div>
            <div onClick={() => monthHandler(nextMonth)} className={classNames(css.arrow, 'grow')}>
                {svgSprite('events-calendar-arrow-right', { className: css.svg })}
            </div>
        </div>
    );
}
